import { ResetAction } from "../ChatAction";

export default function reset(): ResetAction {
    return {
        type: "reset"
    };
}